let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("oiOgV")).then(() => parcelRequire('hV2Ue'));